/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Days_EyebrowInputs */

const en_for_whom_days_eyebrow = /** @type {(inputs: For_Whom_Days_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your day`)
};

const pl_for_whom_days_eyebrow = /** @type {(inputs: For_Whom_Days_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój dzień`)
};

/**
* | output |
* | --- |
* | "Your day" |
*
* @param {For_Whom_Days_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_days_eyebrow = /** @type {((inputs?: For_Whom_Days_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Days_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_days_eyebrow(inputs)
	return en_for_whom_days_eyebrow(inputs)
});